import moment from "moment";

export const formatDate = (date: string) =>
    moment.utc(date.replace(/\.\d\d\d/, "")).local().format('MMM Do YYYY, h:mm A')